import { render, staticRenderFns } from "./Modifylication.vue?vue&type=template&id=55677d94&"
import script from "./Modifylication.vue?vue&type=script&lang=js&"
export * from "./Modifylication.vue?vue&type=script&lang=js&"
import style0 from "./Modifylication.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports